import {TPredicateExpressionDto} from 'features/predicate-expression-form-list';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

const ddRestrictionsApiEndpoint = '/table-reports/drill-restriction';

export interface IFetchDdRestrictionsByIdArgs {
    drillId: number;
}
export const fetchDdRestrictionsById = (
    {drillId}: IFetchDdRestrictionsByIdArgs,
) => performRequest<TPredicateExpressionDto>({
    url: [ddRestrictionsApiEndpoint, drillId].join('/'),
    method: ERequestType.GET,
});

export interface IPostDdRestrictionsByIdArgs {
    drillId: number;
    restrictions: TPredicateExpressionDto;
}
export const postDdRestrictionsById = ({drillId, restrictions}: IPostDdRestrictionsByIdArgs) => performRequest<string>({
    url: [ddRestrictionsApiEndpoint, drillId].join('/'),
    method: ERequestType.POST,
    data: restrictions,
});

export interface IDeleteDdRestrictionsByIdArgs {
    drillId: number;
}
export const deleteDdRestrictionsById = ({drillId}: IDeleteDdRestrictionsByIdArgs) => performRequest<string>({
    url: [ddRestrictionsApiEndpoint, drillId].join('/'),
    method: ERequestType.DELETE,
});
